'use client';
import { useState } from 'react';

export function useClientState<T>(defaultValue: T, key: string) {
  const [value, _setValue] = useState(
    typeof localStorage === 'undefined'
      ? defaultValue
      : localStorage.getItem(key) ?? defaultValue,
  );

  const setValue = (val: T) => {
    _setValue(val);
    localStorage.setItem(key, String(val));
  };

  return [value, setValue] as const;
}
